import { render, staticRenderFns } from "./categoria_listado.vue?vue&type=template&id=39860a66"
import script from "./categoria_listado.vue?vue&type=script&lang=js"
export * from "./categoria_listado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports